// msToHhMm.js

// Function to convert milliseconds to "hh:mm" format
function formatMs(milliseconds) {
	if (typeof milliseconds !== "number" || isNaN(milliseconds)) {
		throw new Error("Invalid input. Expected a number.");
	}

	// Calculate hours, minutes, and seconds
	const hours = Math.floor(milliseconds / 3600000);
	const minutes = Math.floor((milliseconds % 3600000) / 60000);

	// Format the time as "hh:mm"
	const formattedTime = `${String(hours).padStart(2, "0")}:${String(
		minutes
	).padStart(2, "0")}`;

	return formattedTime;
}

module.exports = formatMs;
